import { type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";
import { formatNumbers } from "../../lens-stats/formatters";
import { type GetTopLensesInfoQuery } from "../api/queries";
import { type LensCard, type TopLensCardState } from "../models";

export const mergeTopLensesCards = (
    prevState: TopLensCardState,
    lensDetailsData: GetTopLensesInfoQuery,
    topLensesStats: MyLensesOrganicStatsResponseEntry[],
): LensCard[] => {
    const {
        lenses: { lensesList },
    } = lensDetailsData;

    if (lensesList.length === 0) {
        return [];
    }

    const { numberOfTopLenses, lensCards } = prevState;
    const newLensCards: LensCard[] = [];

    for (const { assetId, statsResponseTimeEntryList } of topLensesStats) {
        const lens = lensesList.find((lens) => lens.unlockableId.toString() === assetId);

        if (lens && lens.__typename === "MyLensesLens") {
            newLensCards.push({
                id: lens.id,
                name: lens.name,
                icon: lens.iconUrl,
                preview: lens.previewUrl,
                value: formatNumbers(
                    Number.parseInt(statsResponseTimeEntryList[0]?.statsList[0]?.statsList[0]?.value ?? ""),
                ),
            });
        }

        if (lensCards.length + newLensCards.length === numberOfTopLenses) {
            break;
        }
    }

    return [...lensCards, ...newLensCards];
};
